

import './App.css';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';


export default function Dashboa() {


  const [responseId, setResponseId] = useState("");
  const [responseState, setResponseState] = useState([])
  const [preloader, setloader] = useState(false)


  const loadscript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");

      script.src = src;
      script.async = true;

      script.onload = () => {
        resolve(true);
      }
      script.onerror = () => {
        resolve(false);
      }


      document.body.appendChild(script);
    })
  }



  const createrazorpayOrder = () => {

    let amount = prompt("Enter the amount");


    setLo(true)
    let data = JSON.stringify({
      amount: amount * 100,
      currency: "INR"
    })


    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: "https://sagarproperties.netlify.app/.netlify/functions/api/orders",
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    }

    axios.request(config).then((response) => {
      console.log(JSON.stringify(response.data))
      handleRazorpayScreen(response.data.amount)
      setLo(false);
    })
      .catch((error) => {
        console.log("Error at", error);
      })
  }

  const handleRazorpayScreen = async (amount) => {
    setLo(false);
    const res = await loadscript("https://checkout.razorpay.com/v1/checkout.js")

    if (!res) {
      alert("Some error at razorpay screen loading")
      return;
    }

    const options = {
      key: 'rzp_test_SSzqDJUamIqr6d',
      amount: amount,
      currency: 'INR',
      name: "Sagar Coders",
      description: "payment done to Sagar",
      image: "https://imgd.aeplcdn.com/310x174/n/cw/ec/167017/creta-ev-exterior-right-front-three-quarter-14.jpeg?isig=0&q=80",
      handler: function (response) {
        setResponseId(response.razorpay_payment_id)
        addPayment(amount);
      },
      prefill: {
        name: "Gateway Abroad",
        email: "sagarrock10oct@gmail.com"
      },
      theme: {
        color: "#F4C430"
      }
    }


    const paymentObject = new window.Razorpay(options)
    paymentObject.open()
    setLo(false);
  }

  function addPayment(amounts) {

    let final = amount + (amounts / 100)

    setLo(true);
    axios.post(`https://sagarproperties.netlify.app/.netlify/functions/api/money/test`, { name: 'test', amount: final }).then((res) => {
      getAmount();
    })
  }

  const paymentFetch = (e) => {
    e.preventDefault();

    const paymentId = e.target.paymentId.value;

    axios.get(`https://sagarproperties.netlify.app/.netlify/functions/api/payment/${paymentId}`).then((response) => {
      console.log(response.data)
      setResponseState(response.data)
    }).catch((error) => {
      console.log(error);
      alert("Error occured");
    })
  }

  const [amount, setAmount] = useState();
  const [lo, setLo] = useState(false);

  function getAmount() {
    setLo(true);
    axios.get(`https://sagarproperties.netlify.app/.netlify/functions/api/money`).then((res) => {
      setAmount(res.data[0].amount);
      setLo(false);
    })
  }

  function joinNow(minus, earn) {

    if (amount < minus) {
      alert("Insufficient balance");
    } else {
      setLo(true);
      let final = earn - minus;
      final = final + amount
      axios.post(`https://sagarproperties.netlify.app/.netlify/functions/api/money/test`, { name: 'test', amount: final }).then((res) => {
        alert(`you have earned ₹${earn - minus}`)
        getAmount();
      })
    }


  }

  useEffect((e) => {
    // e.preventDefault();
    getAmount();
  }, [])


  return (
    <>

      <header class="top-bar">
        <div class="balance-card">
          <span class="label">Total Balance</span>
          <span class="amount">₹ {amount}.00</span>
        </div>


        <button class="logout-btn" onClick={() => { createrazorpayOrder() }}>
          <i class="fas fa-add"></i>
          <span>Add</span>
        </button>


        <Link to='/'>
          <button class="logout-btn">
            <i class="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </button>
        </Link >
      </header>


      <main class="content">



        <div class="opp">
          <h2 class="section-title">Available Opportunities</h2>
          <div>
            <Link to='/withdraw'>

              <button class="withdraw-btn">
                <i class="fas fa-sign-out-alt"></i>
                <span>Withdraw</span>
              </button>
            </Link>
          </div>
        </div>

        <div class="grid-container">
          <section class="join-card">
            <div class="card-icon"><i class="fas fa-rocket"></i></div>
            <div class="info">
              <h3>Starter Pack</h3>
              <p>Join @ <span>₹20</span></p>
              <p class="earn">Earn: <span>₹30</span></p>
            </div>
            <button class="join-btn" onClick={() => { joinNow(20, 30) }}>Join Now</button>
          </section>

          <section class="join-card">
            <div class="card-icon"><i class="fas fa-shield-halved"></i></div>
            <div class="info">
              <h3>Silver Plan</h3>
              <p>Join @ <span>₹30</span></p>
              <p class="earn">Earn: <span>₹50</span></p>
            </div>
            <button class="join-btn" onClick={() => { joinNow(30, 50) }}>Join Now</button>
          </section>

          <section class="join-card">
            <div class="card-icon"><i class="fas fa-gem"></i></div>
            <div class="info">
              <h3>Gold Plan</h3>
              <p>Join @ <span>₹50</span></p>
              <p class="earn">Earn: <span>₹90</span></p>
            </div>
            <button class="join-btn" onClick={() => { joinNow(50, 90) }}>Join Now</button>
          </section>

          <section class="join-card">
            <div class="card-icon"><i class="fas fa-crown"></i></div>
            <div class="info">
              <h3>Platinum</h3>
              <p>Join @ <span>₹100</span></p>
              <p class="earn">Earn: <span>₹200</span></p>
            </div>
            <button class="join-btn" onClick={() => { joinNow(100, 200) }}>Join Now</button>
          </section>

          <section class="join-card">
            <div class="card-icon"><i class="fas fa-star"></i></div>
            <div class="info">
              <h3>VIP Access</h3>
              <p>Join @ <span>₹200</span></p>
              <p class="earn">Earn: <span>₹350</span></p>
            </div>
            <button class="join-btn" onClick={() => { joinNow(200, 350) }}>Join Now</button>
          </section>
        </div>
      </main>


      {
        lo ?
          <>
            <div class="lo">
              <h1>Waiting....</h1>
            </div>
          </>
          : null
      }















      {/* <div className="App">
        <button class="mybutton" onClick={() => { createrazorpayOrder(120) }}>Pay 120rs</button>

        {
          responseId &&
          <p>Payment ID: {responseId}</p>
        }

        <form onSubmit={paymentFetch}>
          <input type='text' name="paymentId" placeholder='Enter your payment ID'></input>
          <button type='submit'>Fetch Payment</button>
          {responseState.length !== 0 && (
            <ul>
              <li>Amount: {responseState.amount / 100}</li>
              <li>Currency: {responseState.currency}</li>
              <li>Method: {responseState.method}</li>
            </ul>
          )}
        </form>


        {
          preloader ?
            <>
              <div class="preloader">
                <img src="https://i.pinimg.com/originals/3e/f0/e6/3ef0e69f3c889c1307330c36a501eb12.gif"></img>
              </div>
            </>
            : null
        }

      </div> */}
    </>
  )

}